import React from "react";
import "./Equi2.css";
import { Container, Row, Col, Card, CardBody, CardHeader, Button } from "reactstrap";

const Equip2 = () => {
  return (
    <div className="engine-dashboard page-content">
      <Container fluid>
        {/* Header Section */}
           <CardHeader className="custom-card-header d-flex justify-content-between align-items-center">
              {/* Left Side */}
              <div className="header-left d-flex align-items-center">
                {/* Time Panel */}
                <div className=" ">
                  <div className="time-box">
                  <h6>UTC: 03:36:16</h6>
                    <h6>LOCAL: 27 05 25</h6>
                  </div>
                 
                </div>
        
                {/* Ship Info */}
                <div className="ship-info d-flex align-items-center">
                  {/* <img
                    src="https://flagcdn.com/w20/sg.png"
                    alt="flag"
                    className="ship-flag me-2"
                  /> */}
                  <div>
                    <h2 className="ship-title mb-0">CLEMENS SCHULTE</h2>
                    <p className="ship-sub mb-0">IMO 9665671 BSM</p>
                  </div>
                  
                </div>
              </div>
        
              {/* Right Side */}
              <div className="header-right d-flex align-items-center">
                {/* Menu */}
                <div className="menu d-flex align-items-center me-3">
                  {[
                    "Dashboard",
                    "AMS",
                    "Alerts",
                    "Alarms",
                    "Voyage",
                    "CCTV",
                    "Status",
                    "Master",
                    "User",
                  ].map((btn, i) => (
                    <button key={i} className="menu-btn mx-2">
                      {btn}
                    </button>
                  ))}
                </div>
        
                {/* Counters */}
                <div className="counters d-flex align-items-center me-3">
                  <div className="counter red">10</div>
                  <div className="counter yellow">19</div>
                </div>
        
                {/* Chat Icon */}
                <div className="chat-icon">
                  <i className="ri-message-2-line"></i>
                </div>
                
              </div>
            </CardHeader>
        
      

        <Row className="mt-3">
          {/* LEFT PANEL */}
          <Col md="3">
            <Card className="mb-3 custom-card">
              <CardHeader>TURBO CHARGER</CardHeader>
              <CardBody>
                <p>T/C RPM NO.1: 7565 RPM</p>
                <p>T/C RPM NO.2: 7324 RPM</p>
                <p>T/C EXH GAS IN NO.1: 277°C</p>
                <p>T/C EXH GAS IN NO.2: 223°C</p>
              </CardBody>
            </Card>

            <Card className="mb-3 custom-card">
              <CardHeader>LO</CardHeader>
              <CardBody>
                <p>T/C LO PRESS NO.1: 1.7 BAR</p>
                <p>T/C LO TEMP NO.1: 55°C</p>
                <p>T/C LO TEMP NO.2: 56°C</p>
              </CardBody>
            </Card>

            <Card className="mb-3 custom-card">
              <CardHeader>FO INLET</CardHeader>
              <CardBody>
                <p>F.O Inlet Press: 8.0 BAR</p>
                <p>Main LO In Press: 4.5 BAR</p>
                <p>Water in Oil High: 0.12 AW</p>
              </CardBody>
            </Card>
          </Col>
          <Col md="9">
          <Col md="9" className="align-items-center">
            <div className="aux-status mt-3 ">
                <span className="status-badge bg-success">NO.1 AUX BLOWER RUN</span>
                <span className="status-badge bg-success">NO.2 AUX BLOWER RUN</span>
                <span className="status-badge bg-info">EXH. MEAN: 240°C</span>
              </div></Col>
       <Row>
    <Col md="3">
            <Card className="mb-5 mt-3 custom-card">
              <CardHeader>ME CYLINDER EXH Gas Out Temp: 230–259°C</CardHeader>
            </Card>
 <Card className="mb-5 custom-card">
              <CardHeader>ME CYLINDER EXH Gas Out Temp: 230–259°C</CardHeader>
            </Card>
             <Card className="mb-5 custom-card">
              <CardHeader>ME CYLINDER EXH Gas Out Temp: 230–259°C</CardHeader>
            </Card>
             <Card className="mb-5 custom-card">
              <CardHeader>ME CYLINDER EXH Gas Out Temp: 230–259°C</CardHeader>
            </Card>
            <Card className="mb-5 custom-card">
              <CardHeader>SHIP SPEED 14.7 Knots</CardHeader>
             
            </Card>
          </Col>
          {/* ENGINE SECTION */}
          <Col md="8" className="text-center">
            <div className="engine-graphic">
              
              <img
                src="/asset/eimm.png" 
                alt="Engine"
                className="engine-img"
              />
             
            </div>
          </Col>
          </Row>
   </Col>
          {/* RIGHT PANEL (optional) */}
      
        </Row>

        {/* BOTTOM ROW */}
        <Row className="mt-3">
          <Col md="3">
            <Card className="custom-card">
              <CardHeader>SHIP OVERALL EFFICIENCY</CardHeader>
              <CardBody>
                <p>ACTUAL: 0</p>
                <p>COR: 0</p>
                <p>SPECIFIC FUEL RATE: 0 g/kWh</p>
              </CardBody>
            </Card>
          </Col>

          <Col md="3">
            <Card className="custom-card">
              <CardHeader>Shaft Power System</CardHeader>
              <CardBody>
                <p>Torque: 1102 kNm</p>
                <p>Power: 5288 kW</p>
                <p>Revolutions: 46.0 RPM</p>
              </CardBody>
            </Card>
          </Col>

          <Col md="3">
            <Card className="custom-card">
              <CardHeader>Scav Air Receiver</CardHeader>
              <CardBody>
                <p>Temp: 38°C</p>
                <p>Inlet Press: 0.4 BAR</p>
                <p>Starting Air Press: 26.6 BAR</p>
              </CardBody>
            </Card>
          </Col>

          <Col md="3">
            <Card className="custom-card">
              <CardHeader>Fuel / Efficiency</CardHeader>
              <CardBody>
                <p>F.O In Temp: 30°C</p>
                <p>Propulsion Efficiency: 3.5 mj/kWh</p>
                <p>Fuel Consumption: 0 kg/hr</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Equip2;
